<app-header />
<div class="story">
  <div class="story_top text-center">
    <div class="bg_6 inline_padding2 story_top_box">
      <ng-container *ngFor="let heading of head">
        <div class="story_top_box_inner" *ngIf="heading.page === currentPage">
          <div class="inline_padding3">
            <span class="text_style_5">Our Story</span>
          </div>
          <div class="inline_padding3 p-top-16">
            <span class="text_style_1" [innerHTML]="heading.page_sub_heading"></span>
          </div>
        </div>

      </ng-container>
    </div>
  </div>
  <div class="inline_padding3 left-align" style="display: flex; align-items: center; margin-left: 8px;">
    <span class="text_style_2" style="margin-right: 10px;">Share Our Story:</span>
    <div class="share-buttons" style="margin-top: 0;"> <!-- Adjust margin as needed -->
      <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
      </button>
      <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
      </button>
      <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
      </button>
      <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
      </button>
      <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
      </button>
      <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
      </button>
      <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
      </button>
      <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
      </button>
      <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
      </button>
      <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
      </button>
      <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
      </button>
      <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
      </button>
      <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
      </button>
      <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
      </button>
      <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
      </button>
      <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
      </button>
      <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
      </button>
    </div>
  </div>


  <div class="story_bottom">
    <div class="story_bottom_box"
      [ngClass]="{ 'grid-layout': yearData.length >= 4, 'flex-layout': yearData.length < 4 }">
      <div class="story_bottom_box_left cursor-pointer" *ngIf="showLeftButton" (click)="scrollLeft()">
        <img src="../../../assets/icons/left_arrow.png" />
      </div>
      <div class="story_bottom_box_mid" #scrollContainer>
        <div class="story_bottom_box_mid_container">
          <div *ngFor="let year of yearData" class="story_bottom_box_mid_container_content">
            <div class="dis-flex-2">
              <div class="text_black_7 story_bottom_box_mid_container_content_year">{{ year.year }}</div>
            </div>
            <div class="p-bot-10 p-top-20">
              <div class="left-border-3">
                <img src="../../../assets/icons/line.png" />
              </div>
            </div>
            <div class="left-border-2 story_bottom_box_mid_container_content_body">
              <ng-container *ngFor="let month of year.months">
                <ng-container *ngIf="month.stories.length > 0">
                  <!-- <div class="text_black_11">{{ month.month | date:'MMMM' }}</div> -->
                  <div *ngFor="let story of month.stories"
                    class="p-top-40 story_bottom_box_mid_container_content_body_item">
                    <div class="flex-container story_bottom_box_mid_container_content_body_item_name">
                      <img src="../../../assets/icons/blue_circle.png" alt="Blue Circle" class="blue-circle" />
                      <div class="text_blue_11">{{ story.date | date:'MMMM yyyy' }}</div>
                    </div>
                    <div class="p-l-24 p-r-24 story_bottom_box_mid_container_content_body_item_parts">
                      <ng-container *ngIf="story.poster">
                        <div class="p-y-16 story_bottom_box_mid_container_content_body_item_parts_image">
                          <img [src]="getStoryImageUrl(story)" alt="{{ story.title }}" />
                        </div>
                      </ng-container>
                      <div class="text_black_1 text-wrap">{{ story.title }}</div>
                      <div class="text_style_9 p-top-10 text-wrap text_align" [innerHtml]="story.description"></div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <!-- <div class="p-top-8 text-wrap p-l-24 p-r-24" *ngIf="year.web_link">
                <div>
                  <span class="text_black_10">Weblink: </span>
                </div>
                <a [href]="year.web_link" class="text_blue_14" target="_blank">
                  {{ year.web_link }}
                </a>
              </div> -->
              <div *ngIf="year.web_link" class="p-top-12">
                <button type="button" class="rounded-pill text_white_1 button_blue_7"
                  (click)="openLink(year.web_link)"><span class="button_blue_1_text"> Weblink</span> <img
                    class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" /></button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="story_bottom_box_right cursor-pointer" *ngIf="showRightButton" (click)="scrollRight()">
        <img src="../../../assets/icons/arrow_right_blue.png" />
      </div>
    </div>
  </div>
</div>
<app-footer />